import React, { Component } from "react";

class BusinessInput extends Component {
	render() {
		return (
			<div>
				{this.props.query["business"] === undefined ? (
					<input
						type="text"
						placeholder={`Looking for ${this.props.query
							.type} specializing in...`}
						onInput={e =>
							this.props.buildSearchQuery("business", e.target.value)}
					/>
				) : (
					<input
						type="text"
						defaultValue={this.props.query["business"]}
						placeholder={`Looking for ${this.props.query
							.type} specializing in...`}
						onInput={e =>
							this.props.buildSearchQuery("business", e.target.value)}
					/>
				)}
			</div>
		);
	}
}

export default BusinessInput;


// WEBPACK FOOTER //
// ./src/components/Search/PanelRight/BusinessInput/BusinessInput.js